// extracted by mini-css-extract-plugin
export default {"container":" supported-networks-icons_container__gZ2pr","icon":" supported-networks-icons_icon__aFtL+"};